import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "auth-phone" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Введите код из СМС", -1)
const _hoisted_3 = { style: {"width":"100%","padding":"40px"} }
const _hoisted_4 = { class: "errors" }
const _hoisted_5 = { class: "form-element" }
const _hoisted_6 = ["data-maska"]
const _hoisted_7 = { class: "error-msg" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "loader"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { style: {"font-size":"10px","margin-top":"10px"} }
const _hoisted_12 = { style: {"position":"absolute","bottom":"0px","width":"100%","padding":"40px"} }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, key) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "error",
            key: key
          }, _toDisplayString(error.message), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          placeholder: "Код",
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event)),
          "data-maska": _ctx.maskCode
        }, null, 8, _hoisted_6), [
          [_vModelText, _ctx.code],
          [_directive_maska]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.code.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("button", {
        disabled: _ctx.loading,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submit())),
        class: "btn",
        style: {"width":"100%","margin-top":"20px"}
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9))
          : _createCommentVNode("", true),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Подтвердить"))
          : _createCommentVNode("", true)
      ], 8, _hoisted_8),
      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.otp.message), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        disabled: _ctx.timer,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendNewCode())),
        class: "btn",
        style: {"width":"100%","margin-top":"20px","background-color":"#383838"}
      }, [
        _createTextVNode(" Отправить код повторно"),
        (_ctx.timer)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "(" + _toDisplayString(_ctx.timer) + ")", 1))
          : _createCommentVNode("", true)
      ], 8, _hoisted_13)
    ])
  ]))
}